import { Expose } from 'class-transformer';
import { IsBoolean, IsEnum, IsOptional, IsString } from 'class-validator';
import { Unit, UnitType } from '../../../entities';

type UpdateUnit = Partial<Omit<Unit, 'id'>> & { id: string; condominiumId: string };

export default class UpdateUnitInput implements UpdateUnit {
  @IsString()
  readonly id: string;

  @IsString()
  @Expose({ name: 'condominium_id' })
  readonly condominiumId: string;

  @IsString()
  @IsOptional()
  readonly number?: string;

  @IsString()
  @IsOptional()
  readonly label?: string;

  @IsString()
  @IsOptional()
  readonly size?: string;

  @IsString()
  @Expose({ name: 'section_id' })
  @IsOptional()
  readonly sectionId?: string;

  @IsEnum(UnitType)
  @IsOptional()
  readonly type?: UnitType;

  @IsBoolean()
  @IsOptional()
  readonly disabled?: boolean;

  constructor(init?: UpdateUnitInput) {
    this.id = init?.id!;
    this.condominiumId = init?.condominiumId!;
    this.number = init?.number;
    this.label = init?.label;
    this.size = init?.size;
    this.sectionId = init?.sectionId;
    this.type = init?.type;
    this.disabled = init?.disabled;
  }
}
